import { render, staticRenderFns } from "./mine-function.vue?vue&type=template&id=5ede5345&scoped=true"
import script from "./mine-function.vue?vue&type=script&lang=js"
export * from "./mine-function.vue?vue&type=script&lang=js"
import style0 from "./mine-function.vue?vue&type=style&index=0&id=5ede5345&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ede5345",
  null
  
)

export default component.exports